import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { EditBarMobile } from './edit-bar-mobile';
import { EditBarWeb } from './edit-bar-web';

type EditBarProps = {
  displayNewsButtons: boolean;
  displayBackButton: boolean;
};
export const EditBar: React.FC<EditBarProps> = ({
  displayNewsButtons,
  displayBackButton,
}) => {
  const { pageContext } = usePageContext();

  if (!pageContext.isEditor) {
    return null;
  }

  return (
    <>
      <EditBarMobile displayBackButton={displayBackButton} />
      <EditBarWeb
        displayNewsButtons={displayNewsButtons}
        displayBackButton={displayBackButton}
      />
    </>
  );
};
